import { render, staticRenderFns } from "./DataTableHeader.vue?vue&type=template&id=06a47dec&functional=true&"
import script from "./DataTableHeader.vue?vue&type=script&lang=js&"
export * from "./DataTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports